import React from 'react';
import FeatherIcon from 'feather-icons-react';
import { Modal } from 'antd';
import PropTypes from 'prop-types';
import { Button } from '../../../components/buttons/buttons';

const Popup = ({ confirmPopup, setConfirmPopup, GetCallback, page }) => {

    async function Click() {
        GetCallback()
    }
    const handleClose = () => {
        setConfirmPopup(false)
    }
    return (
        <>
            <Modal
                title="Cancel?"
                open={confirmPopup}
                onCancel={handleClose}
                maskClosable={false}
                footer={[
                    <div>
                        <Button htmlType="submit" size="small" className="gray-button" onClick={() => handleClose()}>
                            <FeatherIcon icon="x" /> No
                        </Button>
                        <Button htmlType="submit" size="small" onClick={() => Click()} className='button_colors' >
                            <FeatherIcon icon="check" /> Yes
                        </Button>
                    </div >
                ]}
            >
                <div style={{ padding: "0px 20px" }} >
                    <div className='d-flex align-items-start justify-content-center' style={{ fontSize: 15 }}>
                        {page === "Currency" ?
                            <p>You have unsaved changes. Leaving this page will discard the newly added currency. Do you want to continue?</p> :
                            <p>You may have unsaved changes. Leaving this page will discard them. Do you want to continue?</p>}
                    </div>
                </div>
            </Modal >
        </>
    );
};

Popup.propTypes = {
    confirmPopup: PropTypes.bool.isRequired,
    setConfirmPopup: PropTypes.func.isRequired,
    GetCallback: PropTypes.func.isRequired,
    page: PropTypes.string.isRequired,
};

export default Popup;